export default __webpack_public_path__ + "static/media/Icons-36.ad39e858.png";